import { FC, ReactNode, createContext, useState } from "react";
import { BasketHistory, BasketHistoryDeatils, getProduct } from "../axios";
import persianToEnglishNumbers from "../tools/farsiToEnglishNumber";

interface BasketContextProps {
    getBasketHistory: () => Promise<void>;
    orders: any[];
    basketDetailsItems: any[];
    libraryLoaded: boolean;
    basketHistoryStatus: string
}

export const BasketContext = createContext<BasketContextProps | null>(null)

interface ChildrenProps {
    children: ReactNode
}

const BasketProvider: FC<ChildrenProps> = ({ children }) => {
    const [orders, setOrders] = useState<any[]>([])
    const [basketDetailsItems, setBasketDetailsItems] = useState<any[]>([])
    const [libraryLoaded, setLibraryLoaded] = useState<boolean>(true)
    const [basketHistoryStatus, setBasketHistoryStatus] = useState<string>("pending");
    const phoneNumber = localStorage.getItem('phonenumber')   
    
    // console.log("orders: ", orders);
    // console.log("basketdetails items: ", basketDetailsItems);
    
    const getBasketHistory = async () => {
        try {
            setBasketHistoryStatus('pending')
            const response = await BasketHistory(persianToEnglishNumbers(phoneNumber));
            const data = response?.data;
            
            if (data) {
                const items = await Promise.all(
                    data?.map(async (item: any) => {
                        const details = await BasketHistoryDeatils(item.id);
                        return details;
                    })
                );
                                
                setOrders(data)
                setBasketDetailsItems(items)
                setLibraryLoaded(false);
                setBasketHistoryStatus('idle')
            }
        } catch (error) {
            setBasketHistoryStatus('error')
            console.log(error);
        }

    };

    return (
        <BasketContext.Provider value={{ getBasketHistory, orders, basketDetailsItems, libraryLoaded, basketHistoryStatus }}>
            {children}
        </BasketContext.Provider>

    )
}

export default BasketProvider